import axios from "../../../axios";

export function fetchAddressList() {
  const response = axios.get(`/accounts/addresses/`);
  return response;
}
export function addAddress(payload: any, modalType: string, addressId: any) {
  let response;
  if (modalType === "edit") {
    response = axios.put(`/accounts/addresses/${addressId}/`, payload);
  } else {
    response = axios.post(`/accounts/addresses/`, payload);
  }
  return response;
}
export function updateAddress(payload: any) {
  const response = axios.put(`/accounts/addresses/`, payload);
  return response;
}
export function getAddressDetails(payload: any) {
  const response = axios.get(`accounts/addresses/${payload}/`, payload);
  return response;
}
export function deleteAddress(payload: any) {
  const response = axios.delete(`/accounts/addresses/${payload}/`, payload);
  return response;
}
